var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$menu.isOpen)?_c('vk-icon',{attrs:{"name":"chevronup"}}):_c('vk-icon',{attrs:{"name":"chevrondown"}})
}
var staticRenderFns = []

export { render, staticRenderFns }